import React, { useEffect, useState } from "react";
import firebase from "firebase";
import styled from "styled-components";
import Button from "../Button";

const TeacherWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  img {
    width: 68px;
    height: 68px;
    border-radius: 68px;
  }
  hgroup {
    margin-left: 16px;
  }
  h4 {
    font-weight: bold;
    margin-bottom: 0;
    font-size: 18px;
  }

  button {
    margin-left: auto;
  }
`;

type TeacherProps = {
  teacher?: {
    imageUrl?: string;
    name?: string;
    id?: string;
    teacherId?: string;
  };
  type?: "add";
  subtitle?: string;
  onRemove?: (id?: string) => void;
};

const DEFAULT_PROFILE_IMAGE =
  "https://t4.ftcdn.net/jpg/03/46/93/61/360_F_346936114_RaxE6OQogebgAWTalE1myseY1Hbb5qPM.jpg";

const TeacherSlice = ({ teacher, subtitle, onRemove, type }: TeacherProps) => {
  const [imageUrl, setImageUrl] = useState();

  useEffect(() => {
    if (teacher?.imageUrl) {
      firebase
        .storage()
        .ref(teacher.imageUrl)
        .getDownloadURL()
        .then(setImageUrl);
    }
  }, [teacher?.imageUrl]);

  return (
    <TeacherWrapper>
      <div>
        <img src={imageUrl || DEFAULT_PROFILE_IMAGE} alt={teacher?.name} />
      </div>
      <hgroup>
        <h4>{teacher?.name}</h4>
        {subtitle && <span>{subtitle}</span>}
      </hgroup>
      {onRemove && (
        <Button
          small
          onClick={() => onRemove(teacher?.id || teacher?.teacherId)}
        >
          {type === "add" ? "✓" : "✘"}
        </Button>
      )}
    </TeacherWrapper>
  );
};

export default TeacherSlice;
